// third-party
import Avatar from 'react-avatar';
import StencilBox from '../stencils/StencilBox';

const EBookListingOneStencil = ({ data, classes, activeStatus, bgWhite }) => {

    return (
        <div
            className={`edu-card card-type-3 radius-small bg-color-white ${classes ? classes : ""}`}
        >
            <div className="inner">
                <div className="thumbnail">
                    <StencilBox
                        className="sf-blog-img-stencil"
                        width="370px"
                        height="270px"
                        backgroundColor="#6f6b80"
                    />
                </div>

                <div className="content">

                    <h6 className="title placeholder-glow">
                        <span className="placeholder w-100"></span>
                    </h6>
                    <h6 className="title placeholder-glow mt--15">
                        <span className="placeholder w-100"></span>
                    </h6>
                    <div className="row">
                        <div className="col-12 portlet-container portlet-dropzone">
                            <div className="d-flex justify-content-between align-items-center mt-auto">
                                <div className="price-list price-style-03">
                                    <StencilBox
                                        className="sf-blog-btn-stencil"
                                        width="100px"
                                        height="30px"
                                        backgroundColor="#6f6b80"
                                    />
                                </div>
                                <div className="edu-rating rating-default">
                                    <div className="rating eduvibe-course-rating-stars">
                                        <StencilBox
                                            className="sf-blog-btn-stencil"
                                            width="100px"
                                            height="30px"
                                            backgroundColor="#6f6b80"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="author-meta d-flex mt--20">
                        <Avatar className="custom-avatar placeholder placeholder-glow " size={45} round={true} />
                        <span className="placeholder h-100 w-50"></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EBookListingOneStencil;